import React from "react";
import { withRouter } from "react-router";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";

import MPage from "../templates/mpage";
import Infobox from "../components/infobox";
import MsjBox from "../components/msjbox";
import GrupoPropuestas from "../components/grupopropuestas";

import useObtenerMunicipio from "../../utils/useObtenerMunicipio";

const MHome = (props) => {
  //Obtengo la información del municipio desde la url.
  const [municipio, error] = useObtenerMunicipio(props.match.params.munUrl);

  if (error === true) return <Redirect to="/" />;
  if (municipio === undefined) return null;

  return (
    <MPage municipio={municipio}>
      <Infobox municipio={municipio} />

      {(municipio.tituloHome || municipio.msjHome) && (
        <MsjBox titulo={municipio.tituloHome} msj={municipio.msjHome} />
      )}

      {(municipio.urlSiguiente || municipio.urlAnterior) && (
        <div className="row m-3">
          <div className="col-12">
            {municipio.urlAnterior && (
              <Link
                to={`/municipio/${municipio.urlAnterior}`}
                className="btn btn-sm ppr-btn-azul font-weight-bold float-left"
              >
                Presupuesto Participativo Anterior
              </Link>
            )}

            {municipio.urlSiguiente && (
              <Link
                to={`/municipio/${municipio.urlSiguiente}`}
                className="btn btn-sm ppr-btn-azul font-weight-bold float-right"
              >
                Presupuesto Participativo Siguiente
              </Link>
            )}
          </div>
        </div>
      )}

      {municipio.etapa === "seleccion" && (
        <GrupoPropuestas
          municipioId={municipio._id}
          munUrl={municipio.nombreUrl}
          estado={"seleccionada"}
          tituloGrupo={"Propuestas Seleccionadas"}
        />
      )}
      <GrupoPropuestas
        municipioId={municipio._id}
        munUrl={municipio.nombreUrl}
        estado={"aceptada"}
        tituloGrupo={"Propuestas Aprobadas para Votación"}
      />
      <GrupoPropuestas
        municipioId={municipio._id}
        munUrl={municipio.nombreUrl}
        estado={"archivada"}
        tituloGrupo={"Propuestas Archivadas"}
      />
    </MPage>
  );
};

export default withRouter(MHome);
